"use strict";

exports.__esModule = true;
exports.LandingPageWithRoutes = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Core = require("../Core");
var _App = require("../App");
var _AppRoute = require("./AppRoute");
var _Theme = require("../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var FlexWrapContainer = _styledComponents["default"].div.withConfig({
  displayName: "LandingPageWithRoutes__FlexWrapContainer",
  componentId: "sc-1bd0fnz-0"
})(["display:flex;flex-wrap:wrap;"]);
var BetaLabel = _styledComponents["default"].div.withConfig({
  displayName: "LandingPageWithRoutes__BetaLabel",
  componentId: "sc-1bd0fnz-1"
})(["color:", ";font-size:", ";background-color:#ffe699;margin-right:30px;padding:0 10px;border-radius:3px;"], (0, _Theme.val)("color"), (0, _Theme.val)("fontSizeLarge"));
var LandingPageWithRoutes = exports.LandingPageWithRoutes = function LandingPageWithRoutes(props) {
  var titleText = props.titleText,
    titleId = props.titleId,
    isBeta = props.isBeta,
    landingPageTestId = props.landingPageTestId,
    screenElements = props.screenElements;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var title = translate(titleId, titleText);
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: title
  }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: title
  }, isBeta && /*#__PURE__*/_react["default"].createElement(BetaLabel, null, "Beta")), /*#__PURE__*/_react["default"].createElement(FlexWrapContainer, {
    "data-testid": landingPageTestId,
    style: {
      margin: 25
    }
  }, screenElements.map(function (screenDetails, index) {
    return /*#__PURE__*/_react["default"].createElement(_AppRoute.AppRoute, _extends({}, screenDetails, {
      key: index
    }));
  })));
};